<div class="right_col screen-height v_scrnss edit-page" role="main">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 mb-4">
        <h1 class="text-left font-weight-bold text-uppercase text-dark">Approve Consultants</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5 class="section-title">Pending Consultants</h5>
            <div class="alert alert-danger" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>

            <div class="text-center py-4" *ngIf="loading">
              <span>Loading pending consultants...</span>
            </div>

            <div class="table-scroll" *ngIf="!loading">
              <table class="table row-border hover mat-table consultants-table" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th class="th-heading">Name</th>
                    <th class="th-heading">Email</th>
                    <th class="th-heading">Phone</th>
                    <th class="th-heading">Specialization</th>
                    <th class="th-heading">Fees</th>
                    <th class="th-heading">Documents</th>
                    <th class="th-heading">Applied On</th>
                    <th class="th-heading">Action</th>
                  </tr>
                </thead>

                <tbody *ngIf="consultants?.length">
                  <tr *ngFor="let consultant of consultants; trackBy: trackByConsultant">
                    <td class="cell-wrap" [title]="consultant.fullName || '-'">{{ consultant.fullName || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.email || '-'">{{ consultant.email || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.phone || '-'">{{ consultant.phone || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.specialization || '-'">{{ consultant.specialization || '-' }}</td>
                    <td class="fees-cell">
                      <div class="fee-list" *ngIf="consultant?.fees; else noFees">
                        <span class="fee-item" [title]="'Chat: ' + getFeeValue(consultant?.fees?.chat) + ' ' + getFeeCurrency(consultant)">
                          Chat: {{ getFeeValue(consultant?.fees?.chat) }} {{ getFeeCurrency(consultant) }}
                        </span>
                        <span class="fee-item" [title]="'Audio: ' + getFeeValue(consultant?.fees?.audio) + ' ' + getFeeCurrency(consultant)">
                          Audio: {{ getFeeValue(consultant?.fees?.audio) }} {{ getFeeCurrency(consultant) }}
                        </span>
                        <span class="fee-item" [title]="'Video: ' + getFeeValue(consultant?.fees?.video) + ' ' + getFeeCurrency(consultant)">
                          Video: {{ getFeeValue(consultant?.fees?.video) }} {{ getFeeCurrency(consultant) }}
                        </span>
                      </div>
                      <ng-template #noFees>
                        <span class="text-muted">No fees</span>
                      </ng-template>
                    </td>
                    <td class="documents-cell">
                      <div class="doc-list" *ngIf="consultant.documents?.length; else noDocuments">
                        <a
                          *ngFor="let document of consultant.documents; let i = index; trackBy: trackByDocument"
                          class="doc-link"
                          [href]="getDocumentUrl(document.path)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            *ngIf="isImageFile(document?.name, document?.path)"
                            [src]="getDocumentUrl(document.path)"
                            [alt]="getDocumentName(document, i)"
                            class="doc-thumb"
                          >
                          <span class="doc-name">{{ getDocumentName(document, i) }}</span>
                        </a>
                      </div>
                      <ng-template #noDocuments>
                        <span class="text-muted">No documents</span>
                      </ng-template>
                    </td>
                    <td>{{ consultant.createdAt | date:'mediumDate' }}</td>
                    <td class="action-cell">
                      <div class="action-buttons">
                        <button
                          class="btn btn-outline-success user-glyf"
                          (click)="approveConsultant(consultant)"
                          [disabled]="isActionLoading(consultant._id)"
                        >
                          Approve
                        </button>
                        <button
                          class="btn btn-outline-danger user-glyf"
                          (click)="openRejectModal(consultant)"
                          [disabled]="isActionLoading(consultant._id)"
                        >
                          Reject
                        </button>
                      </div>
                      <small class="text-muted d-block mt-1" *ngIf="isActionLoading(consultant._id)">Updating...</small>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="!consultants?.length">
                  <tr>
                    <td colspan="8" class="no-data-available">No pending consultants found.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-wrapper" *ngIf="!loading && totalPages > 1">
              <button class="btn btn-light user-glyf" (click)="changePage(page - 1)" [disabled]="page <= 1">
                Previous
              </button>
              <span class="page-info">Page {{ page }} of {{ totalPages }} ({{ total }} total)</span>
              <button class="btn btn-light user-glyf" (click)="changePage(page + 1)" [disabled]="page >= totalPages">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5 class="section-title">Approved Consultants</h5>
            <div class="alert alert-danger" *ngIf="approvedErrorMessage">
              {{ approvedErrorMessage }}
            </div>

            <div class="text-center py-4" *ngIf="approvedLoading">
              <span>Loading approved consultants...</span>
            </div>

            <div class="table-scroll" *ngIf="!approvedLoading">
              <table class="table row-border hover mat-table consultants-table" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th class="th-heading">Name</th>
                    <th class="th-heading">Email</th>
                    <th class="th-heading">Phone</th>
                    <th class="th-heading">Specialization</th>
                    <th class="th-heading">Fees</th>
                    <th class="th-heading">Documents</th>
                    <th class="th-heading">Applied On</th>
                    <th class="th-heading">Status</th>
                  </tr>
                </thead>

                <tbody *ngIf="approvedConsultants?.length">
                  <tr *ngFor="let consultant of approvedConsultants; trackBy: trackByConsultant">
                    <td class="cell-wrap" [title]="consultant.fullName || '-'">{{ consultant.fullName || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.email || '-'">{{ consultant.email || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.phone || '-'">{{ consultant.phone || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.specialization || '-'">{{ consultant.specialization || '-' }}</td>
                    <td class="fees-cell">
                      <div class="fee-list" *ngIf="consultant?.fees; else noApprovedFees">
                        <span class="fee-item" [title]="'Chat: ' + getFeeValue(consultant?.fees?.chat) + ' ' + getFeeCurrency(consultant)">
                          Chat: {{ getFeeValue(consultant?.fees?.chat) }} {{ getFeeCurrency(consultant) }}
                        </span>
                        <span class="fee-item" [title]="'Audio: ' + getFeeValue(consultant?.fees?.audio) + ' ' + getFeeCurrency(consultant)">
                          Audio: {{ getFeeValue(consultant?.fees?.audio) }} {{ getFeeCurrency(consultant) }}
                        </span>
                        <span class="fee-item" [title]="'Video: ' + getFeeValue(consultant?.fees?.video) + ' ' + getFeeCurrency(consultant)">
                          Video: {{ getFeeValue(consultant?.fees?.video) }} {{ getFeeCurrency(consultant) }}
                        </span>
                      </div>
                      <ng-template #noApprovedFees>
                        <span class="text-muted">No fees</span>
                      </ng-template>
                    </td>
                    <td class="documents-cell">
                      <div class="doc-list" *ngIf="consultant.documents?.length; else noApprovedDocuments">
                        <a
                          *ngFor="let document of consultant.documents; let i = index; trackBy: trackByDocument"
                          class="doc-link"
                          [href]="getDocumentUrl(document.path)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            *ngIf="isImageFile(document?.name, document?.path)"
                            [src]="getDocumentUrl(document.path)"
                            [alt]="getDocumentName(document, i)"
                            class="doc-thumb"
                          >
                          <span class="doc-name">{{ getDocumentName(document, i) }}</span>
                        </a>
                      </div>
                      <ng-template #noApprovedDocuments>
                        <span class="text-muted">No documents</span>
                      </ng-template>
                    </td>
                    <td>{{ consultant.createdAt | date:'mediumDate' }}</td>
                    <td class="status-cell">
                      <span class="status-badge status-approved">Approved</span>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="!approvedConsultants?.length">
                  <tr>
                    <td colspan="8" class="no-data-available">No approved consultants found.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-wrapper" *ngIf="!approvedLoading && approvedTotalPages > 1">
              <button class="btn btn-light user-glyf" (click)="changeApprovedPage(approvedPage - 1)" [disabled]="approvedPage <= 1">
                Previous
              </button>
              <span class="page-info">Page {{ approvedPage }} of {{ approvedTotalPages }} ({{ approvedTotal }} total)</span>
              <button class="btn btn-light user-glyf" (click)="changeApprovedPage(approvedPage + 1)" [disabled]="approvedPage >= approvedTotalPages">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5 class="section-title">Rejected Consultants</h5>
            <div class="alert alert-danger" *ngIf="rejectedErrorMessage">
              {{ rejectedErrorMessage }}
            </div>

            <div class="text-center py-4" *ngIf="rejectedLoading">
              <span>Loading rejected consultants...</span>
            </div>

            <div class="table-scroll" *ngIf="!rejectedLoading">
              <table class="table row-border hover mat-table consultants-table" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th class="th-heading">Name</th>
                    <th class="th-heading">Email</th>
                    <th class="th-heading">Phone</th>
                    <th class="th-heading">Specialization</th>
                    <th class="th-heading">Fees</th>
                    <th class="th-heading">Documents</th>
                    <th class="th-heading">Applied On</th>
                    <th class="th-heading">Status</th>
                  </tr>
                </thead>

                <tbody *ngIf="rejectedConsultants?.length">
                  <tr *ngFor="let consultant of rejectedConsultants; trackBy: trackByConsultant">
                    <td class="cell-wrap" [title]="consultant.fullName || '-'">{{ consultant.fullName || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.email || '-'">{{ consultant.email || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.phone || '-'">{{ consultant.phone || '-' }}</td>
                    <td class="cell-wrap" [title]="consultant.specialization || '-'">{{ consultant.specialization || '-' }}</td>
                    <td class="fees-cell">
                      <div class="fee-list" *ngIf="consultant?.fees; else noRejectedFees">
                        <span class="fee-item" [title]="'Chat: ' + getFeeValue(consultant?.fees?.chat) + ' ' + getFeeCurrency(consultant)">
                          Chat: {{ getFeeValue(consultant?.fees?.chat) }} {{ getFeeCurrency(consultant) }}
                        </span>
                        <span class="fee-item" [title]="'Audio: ' + getFeeValue(consultant?.fees?.audio) + ' ' + getFeeCurrency(consultant)">
                          Audio: {{ getFeeValue(consultant?.fees?.audio) }} {{ getFeeCurrency(consultant) }}
                        </span>
                        <span class="fee-item" [title]="'Video: ' + getFeeValue(consultant?.fees?.video) + ' ' + getFeeCurrency(consultant)">
                          Video: {{ getFeeValue(consultant?.fees?.video) }} {{ getFeeCurrency(consultant) }}
                        </span>
                      </div>
                      <ng-template #noRejectedFees>
                        <span class="text-muted">No fees</span>
                      </ng-template>
                    </td>
                    <td class="documents-cell">
                      <div class="doc-list" *ngIf="consultant.documents?.length; else noRejectedDocuments">
                        <a
                          *ngFor="let document of consultant.documents; let i = index; trackBy: trackByDocument"
                          class="doc-link"
                          [href]="getDocumentUrl(document.path)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            *ngIf="isImageFile(document?.name, document?.path)"
                            [src]="getDocumentUrl(document.path)"
                            [alt]="getDocumentName(document, i)"
                            class="doc-thumb"
                          >
                          <span class="doc-name">{{ getDocumentName(document, i) }}</span>
                        </a>
                      </div>
                      <ng-template #noRejectedDocuments>
                        <span class="text-muted">No documents</span>
                      </ng-template>
                    </td>
                    <td>{{ consultant.createdAt | date:'mediumDate' }}</td>
                    <td class="status-cell">
                      <span class="status-badge status-rejected">Rejected</span>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="!rejectedConsultants?.length">
                  <tr>
                    <td colspan="8" class="no-data-available">No rejected consultants found.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-wrapper" *ngIf="!rejectedLoading && rejectedTotalPages > 1">
              <button class="btn btn-light user-glyf" (click)="changeRejectedPage(rejectedPage - 1)" [disabled]="rejectedPage <= 1">
                Previous
              </button>
              <span class="page-info">Page {{ rejectedPage }} of {{ rejectedTotalPages }} ({{ rejectedTotal }} total)</span>
              <button class="btn btn-light user-glyf" (click)="changeRejectedPage(rejectedPage + 1)" [disabled]="rejectedPage >= rejectedTotalPages">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': showRejectDialog ? 'block' : 'none'}" *ngIf="showRejectDialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center mb-3">
              <h4 class="mb-0">Reject Consultant</h4>
            </div>
            <p class="mb-2">
              Reason for rejecting <strong>{{ selectedConsultant?.fullName || 'this consultant' }}</strong>:
            </p>
            <textarea
              class="form-control"
              rows="4"
              [(ngModel)]="rejectionReason"
              name="rejectionReason"
              placeholder="Enter rejection reason"
            ></textarea>
          </div>
          <div class="modal-footer">
            <div class="col-sm-6">
              <button type="button" class="btn btn-default smingl_button" (click)="closeRejectModal()" style="border-color: #117a8b;">
                Cancel
              </button>
            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <button
                  type="button"
                  class="btn btn-danger btn-lg smingl_button"
                  [disabled]="!rejectionReason.trim() || isActionLoading(selectedConsultant?._id)"
                  (click)="confirmReject()"
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
